<template>
  <section class="stats" id="statistics-section">
    <div class="container">
      <h2 class="title">Статистика компаний РФ</h2>

      <div class="content">
        <!-- Таблица -->
        <div class="stats-table">
          <div class="stats-header">
            <div>Регион</div>
            <div>Среднее кол-во, млн рублей</div>
            <div>Общее кол-во, млн рублей</div>
            <div>Доля</div>
          </div>
          <div class="stats-row" v-for="region in regions" :key="region.name">
            <div>{{ region.name }}</div>
            <div class="bar-cell">
              <span class="bar" :style="{ width: region.barWidth + '%' }">{{
                region.avg
              }}</span>
            </div>
            <div>{{ region.total }}</div>
            <div>{{ region.share }}</div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
const regions = [
  {
    name: "Москва",
    avg: "212.5",
    total: "1 200 000",
    share: "18.2%",
    barWidth: 100,
  },
  {
    name: "Санкт-Петербург",
    avg: "180.2",
    total: "870 000",
    share: "13.1%",
    barWidth: 85,
  },
  {
    name: "Сибирь",
    avg: "143.9",
    total: "720 000",
    share: "10.9%",
    barWidth: 70,
  },
  {
    name: "Московская обл.",
    avg: "160.3",
    total: "810 000",
    share: "12.2%",
    barWidth: 75,
  },
  {
    name: "Тюменская обл.",
    avg: "132.0",
    total: "590 000",
    share: "9.1%",
    barWidth: 60,
  },
  {
    name: "Краснодарский край",
    avg: "125.7",
    total: "550 000",
    share: "8.3%",
    barWidth: 55,
  },
];
const stats = [
  {
    region: "Москва",
    avg: "197,76",
    total: "107 955 555,34",
    percent: "55,54%",
  },
  {
    region: "Санкт-Петербург",
    avg: "197,76",
    total: "107 955 555,34",
    percent: "55,54%",
  },
  {
    region: "Сибирь",
    avg: "197,76",
    total: "107 955 555,34",
    percent: "55,54%",
  },
  {
    region: "Московская обл.",
    avg: "197,76",
    total: "107 955 555,34",
    percent: "55,54%",
  },
  {
    region: "Тюменская обл.",
    avg: "197,76",
    total: "107 955 555,34",
    percent: "55,54%",
  },
  {
    region: "Краснодарский край",
    avg: "197,76",
    total: "107 955 555,34",
    percent: "55,54%",
  },
];
</script>

<style scoped lang="scss">
.stats {
  background: rgba(245, 247, 250, 1);
  padding: 60px 20px;
  box-shadow: 0px 8px 24px 0px rgba(129, 135, 189, 0.15);
}
.container {
  max-width: 1200px;
  margin: 0 auto;
}
.title {
  font-size: 45px;
  font-weight: 700;
  margin-bottom: 40px;
  text-align: center;
  color: rgba(62, 62, 62, 1);

  @media (max-width: 768px) {
    font-size: 24px;
  }
}
.content {
  display: flex;
  flex-wrap: wrap;
  gap: 40px;
  align-items: flex-start;
}
.map {
  flex: 1;
  min-width: 300px;
  margin: auto;
}
.map img {
  max-width: 100%;
  height: auto;
}
.table {
  flex: 2;
  min-width: 320px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.table-row {
  display: grid;
  grid-template-columns: 1fr 1.2fr 1.2fr 0.8fr;
  gap: 20px;
  padding: 10px 12px;
  border-radius: 8px;
  font-size: 22px;
  color: rgba(62, 62, 62, 1);
}
.table-head {
  font-weight: 400;
  background: rgba(230, 242, 253, 1);
  box-shadow: none;
  color: rgba(62, 62, 62, 1);
  font-size: 16px;
}
.active {
  background: rgba(238, 245, 251, 1);
  border: 1px solid rgba(0, 199, 130, 1);
}

.company-stats {
  margin-top: 80px;
  background: white;
  border-radius: 16px;
  padding: 40px 32px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.05);
}
.stats-table {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
}
.stats-header,
.stats-row {
  display: grid;
  grid-template-columns: 1.5fr 3fr 1.5fr 1fr;
  gap: 16px;
  align-items: center;
  padding: 12px;

  @media (max-width: 768px) {
    font-size: 14px;
  }
}
.stats-header {
  font-weight: 500;
  font-size: 16px;
  color: rgba(62, 62, 62, 1);
  padding: 20px;
  background-color: rgba(230, 242, 253, 1);
  border-radius: 10px;
  border-bottom: none;

  @media (max-width: 768px) {
    font-size: 14px;
  }
}
.bar-cell {
  position: relative;
  height: 24px;
}
.bar {
  display: inline-block;
  background-color: rgba(0, 199, 130, 1);
  color: white;
  padding: 12px;
  border-radius: 10px;
  font-weight: 500;
  font-size: 14px;
  white-space: nowrap;
}
@media (max-width: 768px) {
  .stats-header,
  .stats-row {
    grid-template-columns: 1.1fr 1.35fr 1fr 0.75fr;
    gap: 12px;
    padding: 10px;
    align-items: start;
  }

  .stats-header {
    font-size: 13px;
  }

  .stats-row {
    font-size: 14px;
  }

  .stats-header > div,
  .stats-row > div {
    text-align: left;
    justify-self: start;
    min-width: 0;
    word-break: break-word;
  }

  .bar-cell {
    display: flex;
    justify-content: flex-start;
    // align-items: center;
    min-width: 0;
  }

  .bar {
    display: inline-flex;
    align-items: center;
    justify-content: flex-start;
    min-height: 42px;
    min-width: 68px;
    padding: 0 10px;
    font-size: 13px;
    line-height: 1;
    white-space: nowrap;
    box-sizing: border-box;
  }
}
</style>
